export const pinterestIcon = () => (
  <svg fill='none' height='21' width='21' xmlns='http://www.w3.org/2000/svg'>
    <path
      clipRule='evenodd'
      d='M4.567 1.732a10.275 10.275 0 1 1 11.416 17.086A10.275 10.275 0 0 1 4.567 1.732Zm5.675 11.68c.375.192.793.287 1.215.276 2.829 0 4.749-2.58 4.75-6.035a5.262 5.262 0 0 0-5.572-5.042c-4.182 0-6.29 3-6.29 5.5a3.39 3.39 0 0 0 1.8 3.362.3.3 0 0 0 .441-.221l.09-.35.09-.356a.427.427 0 0 0-.127-.49 2.538 2.538 0 0 1-.581-1.726 4.17 4.17 0 0 1 4.34-4.214c2.362 0 3.662 1.444 3.662 3.373 0 2.538-1.122 4.68-2.79 4.68a1.362 1.362 0 0 1-1.389-1.7c.347-1.017.607-2.062.776-3.123A1.176 1.176 0 0 0 9.47 6.025c-.944 0-1.7.978-1.7 2.278-.006.479.09.954.28 1.393l-1.132 4.8a9.878 9.878 0 0 0-.027 3.344.117.117 0 0 0 .209.05 9.377 9.377 0 0 0 1.588-2.883c.108-.391.619-2.419.619-2.419.238.348.56.632.935.824Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
